import React, { useEffect, useState } from "react";
import MainPageComponent from "./main.page";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux"
import {AccessRights} from "lib/constants/accessRights"
import LoadingComponent from "components/loading";
import { getLang } from "app/feature/constants";
import {canAccess} from "../../../profile/redux/selector/profile.selector";

function MainPageContainer() {
  const history = useHistory();
  const hasEmployeeViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Employee.READ));
  const hasOrganisationStructureViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.OrganisationStructure.MODULE));
  const lang = useSelector(state => state.constant.languages);

  useEffect(() => {
    if(!hasOrganisationStructureViewAccessRight){
      history.push('/admin/dashboard')
    }
  }, [history, hasOrganisationStructureViewAccessRight])

  const [activeIndex, setActiveIndex] = useState(0);
  
  if (!hasOrganisationStructureViewAccessRight) return <LoadingComponent />;
  const tabLabels = [getLang(lang,"label.STRUCTURE_OVERVIEW")];

  const handleChange = (event, index) => {
    setActiveIndex(index);
  };

  return (
    <>
      <MainPageComponent
        hasEmployeeViewAccessRight={hasEmployeeViewAccessRight}
        handleChange={handleChange}
        activeIndex={activeIndex}
        tabLabels={tabLabels}
        lang={lang}
      />
    </>
  );
}

export default MainPageContainer;
